import { API_REGIONS } from "../constants/api";

export default (axios) => ({
    // Получение списка регионов
    getRegions() {
        return axios
            .get(API_REGIONS)
            .then(({ data }) => {
                return data;
            });
    },

    // Получение регионов, сгруппированных по округам
    getRegionsGroupedByDistrict() {
        return axios
            .get(`${API_REGIONS}/grouped-by-district`)
            .then(({ data }) => {
                return data;
            });
    },

    // Получение региона по ID
    getRegion(id) {
        return axios
            .get(`${API_REGIONS}/${id}`)
            .then(({ data }) => {
                return data;
            });
    },

    // Получение городов региона
    getCities(regionId) {
        return axios
            .get(`${API_REGIONS}/${regionId}/cities`)
            .then(({ data }) => {
                return data;
            });
    },
});
